import { MutationTree } from 'vuex';
import Cookies from 'js-cookie';
import { ProfileState } from '@/store/profile/types';

const mutations: MutationTree<ProfileState> = {
  login(state, payload: ProfileState) {
    const { user, session } = payload;
    state.user = user;
    state.session = session;
    if (session) {
      Cookies.set('session', session);
    }
  },
  logout(state) {
    state.user = undefined;
    state.session = undefined;
    Cookies.remove('session');
  },
  setSession(state, payload) {
    state.session = payload;
  },
};

export default mutations;
